import styles from './PublishPanel.module.scss'

import Button from '@/components/Button'
import { getReviewButtonTitle } from '@/pages/app/AnalyticsPortal/utils'

interface PublishPanelProps {
  hasChanges: boolean
  isSaving: boolean
  isFetchingPreview: boolean
  isPublishing: boolean
  onSave: () => void
  onPublish: () => void
}

const getPublishButtonText = (isFetchingPreview: boolean, isPublishing: boolean): string => {
  if (isFetchingPreview) return 'Loading...'
  if (isPublishing) return 'Publishing...'
  return 'Publish'
}

const PublishPanel = ({
  hasChanges,
  isSaving,
  isFetchingPreview,
  isPublishing,
  onSave,
  onPublish,
}: PublishPanelProps) => {
  const isPublishDisabled = isFetchingPreview || isPublishing || hasChanges

  return (
    <div className={styles.publishPanel}>
      {hasChanges && (
        <Button
          title={getReviewButtonTitle(isSaving)}
          onClick={onSave}
          type="light"
          isLoading={isSaving}
          isDisabled={isSaving}
        />
      )}
      <div title={hasChanges ? 'Save your changes before publishing' : undefined}>
        <Button
          title={getPublishButtonText(isFetchingPreview, isPublishing)}
          onClick={onPublish}
          type="dark"
          isLoading={isFetchingPreview || isPublishing}
          isDisabled={isPublishDisabled}
        />
      </div>
    </div>
  )
}

export default PublishPanel
